import { useTranslation } from 'react-i18next'

interface BeforeAfterDiffProps {
  before: string
  after: string
  label?: string
}

export function BeforeAfterDiff({ before, after, label }: BeforeAfterDiffProps) {
  const { t } = useTranslation()

  return (
    <div className="mt-2">
      {label && (
        <span className="text-xs font-medium text-neutral-500 dark:text-neutral-400 mb-1 block">
          {label}
        </span>
      )}
      <div className="grid grid-cols-2 gap-2 text-xs">
        <div className="bg-red-50 dark:bg-red-900/10 rounded-lg p-3 border border-red-100 dark:border-red-900/20">
          <span className="text-red-600 dark:text-red-400 font-semibold block mb-1">
            {t('amazonListing.scores.before')}
          </span>
          <span className="text-neutral-700 dark:text-neutral-300 leading-relaxed">
            {before}
          </span>
        </div>
        <div className="bg-green-50 dark:bg-green-900/10 rounded-lg p-3 border border-green-100 dark:border-green-900/20">
          <span className="text-green-600 dark:text-green-400 font-semibold block mb-1">
            {t('amazonListing.scores.after')}
          </span>
          <span className="text-neutral-700 dark:text-neutral-300 leading-relaxed">
            {after}
          </span>
        </div>
      </div>
    </div>
  )
}
